export const FETCH_ALL = "FETCH_ALL"
export const CREATE = "CREATE" 
export const UPDATE = "UPDATE"
export const DELETE_POTLUCK = "DELETE POTLUCK"